export const sortListByDate =(list:any)=>{
    const sortedList = list.sort((a: any, b: any) => {
        const dateA = new Date(a?.startDate?.$date);
        const dateB = new Date(b?.startDate?.$date);
        return dateB.getTime() - dateA.getTime();
    });
    return sortedList;
}